export default "__VITE_ASSET__GhCGIzjX__"